/**
 * Diagnostic utility to check restroom visibility issues
 * Run this in browser console to see what's happening
 */

import firebaseService from '../services/firebaseService';

export async function diagnoseRestroomVisibility() {
  try {
    // Get all restrooms (raw, unfiltered)
    const allRestrooms = await firebaseService.getAllRestroomsRaw();
    // Count verified vs unverified
    const verified = allRestrooms.filter(r => r.verified === true);
    const unverified = allRestrooms.filter(r => r.verified !== true);
    // Check for missing critical fields in new features
    const missingRequiresKey = allRestrooms.filter(r => r.requiresKey === undefined);
    const missingHasShowers = allRestrooms.filter(r => r.hasShowers === undefined);
    // Check categories
    const categories = {};
    allRestrooms.forEach(r => {
      const cat = r.category || 'unknown';
      categories[cat] = (categories[cat] || 0) + 1;
    });
    // List unverified restrooms
    const unverifiedList = unverified.map(r => ({ name: r.name, id: r.id }));
    // Check for invalid coordinates
    const invalidCoords = allRestrooms.filter(r => 
      isNaN(r.latitude) || isNaN(r.longitude) || 
      r.latitude === null || r.longitude === null
    );
    const invalidCoordsList = invalidCoords.map(r => ({ 
      name: r.name, 
      lat: r.latitude, 
      lng: r.longitude 
    }));
    return {
      total: allRestrooms.length,
      verified: verified.length,
      unverified: unverified.length,
      missingRequiresKey: missingRequiresKey.length,
      missingHasShowers: missingHasShowers.length,
      categories,
      unverifiedList,
      invalidCoords: invalidCoords.length,
      invalidCoordsList
    };
  } catch (error) {
    console.error('❌ Diagnostic failed:', error);
    throw error;
  }
}

// Make it available in console
window.diagnoseRestroomVisibility = diagnoseRestroomVisibility;
